import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmailVerificationComponent } from '../../email-verification/_pages/email-verification.component';
import { CustomerFormComponent } from '../../customer-form/_pages/customer-form.component';
import { SharedService } from '../../shared/services/shared.service';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingScreenService } from 'app/shared/services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-parent',
  standalone: true,
  imports: [
    EmailVerificationComponent,
    CustomerFormComponent,
    TranslateModule,
    MatProgressSpinnerModule
],
  templateUrl: './parent.component.html',
  styleUrls: ['./parent.component.scss'],
})
export class ParentComponent implements OnInit, OnDestroy {
  showEmailForm: boolean = true; // Determines which form to display
  private stepSubscription: Subscription;

  constructor(private sharedService: SharedService, private loadingScreenService: LoadingScreenService) {
    this.stepSubscription = new Subscription();

    
  }

  ngOnInit() {
    // Subscribe to the current step from the shared service
    this.stepSubscription = this.sharedService
      .getCurrentStep()
      .subscribe((step) => {
        // If step is greater than 1, show the customer form
        if (step > 1) {
          this.showEmailForm = false;
        }
      });
  }

  ngOnDestroy() {
    if (this.stepSubscription) {
      this.stepSubscription.unsubscribe();
    }
  }

  // Triggered when OTP is verified
  handleOtpVerified(): void {
    this.loadingScreenService.show();
    this.showEmailForm = false; // Switch to the Customer Form
    this.sharedService.setCurrentStep(1); // Set the current step to 1 (company details)
    this.loadingScreenService.hide();
  }

  // Method to switch back to email form if needed
  switchToCustomerForm(): void {
    this.showEmailForm = false;
  }
}
